// src/components/Footer.jsx
import { Link } from "react-router-dom";
import Wordmark from "./Wordmark";
import { SITE, whatsappLink } from "../data/site";
import "./Footer.css";

const NAV = [
  { to: "/", label: "Início" },
  { to: "/servicos", label: "Serviços" },
  { to: "/portfolio", label: "Portfólio" },
  { to: "/sobre", label: "Sobre" },
  { to: "/contato", label: "Contato" },
];

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <Wordmark className="footer-logo" />
          <p className="footer-tagline">Vídeo e fotografia de imóveis com drone</p>
          <p>{SITE.endereco}</p>
          <p>{SITE.caixaPostal}</p>
          <p>CNPJ: {SITE.cnpj}</p>
        </div>

        <div className="footer-links">
          <span className="footer-label">Navegação</span>
          {NAV.map((item) => (
            <Link key={item.to} to={item.to}>
              {item.label}
            </Link>
          ))}
        </div>

        <div className="footer-links">
          <span className="footer-label">Contato</span>
          <a href={whatsappLink()} target="_blank" rel="noreferrer">
            WhatsApp · {SITE.whatsappExibicao}
          </a>
          {SITE.instagramUrl && (
            <a href={SITE.instagramUrl} target="_blank" rel="noreferrer">
              Instagram{SITE.instagramHandle && ` · ${SITE.instagramHandle}`}
            </a>
          )}
          {SITE.youtubeUrl && (
            <a href={SITE.youtubeUrl} target="_blank" rel="noreferrer">
              YouTube
            </a>
          )}
          <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
        </div>
      </div>
      <div className="footer-coords">
        D•REC PRODUÇÕES · {SITE.areaAtendimento.toUpperCase()} · © {new Date().getFullYear()}
      </div>
    </footer>
  );
}

export default Footer;
